module.exports = __webpack_public_path__ + "img/investment.d8e788d2.svg";